import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "master-plan" }

import { computed, ref } from 'vue';
    import MapHeader from '@/components/map/MapHeader.vue';
    import MapFooter from '@/components/map/MapFooter.vue';
    import MapFigure from '@/components/map/MapFigure.vue';
    import ListMobWindow from '../modals/ListMobWindow.vue';
    import CardHouse from '@/components/house/CardHouse.vue';
    import CardPlotZone from '@/components/map/map-sections/CardPlot.vue';
    import LandPLotModal from '@/components/modals/LandPlot/index.vue';
    import SliderFullScreen from '@/components/modals/SliderFullScreen.vue';
    import { cardSettingsStore } from '@/store/modules/CardSettings';
    import { galleryStore } from '@/store/modules/Gallery';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Map',
  setup(__props) {

    let isListMobWindowVisible = ref(false);
    let isMasterPlan = ref(true);

    const isWindowHouseWindowVisible = computed(() => {
        return cardSettingsStore.IS_SHOW_LAND_PLOT_CARD_IN_MODAL;
    });

    function changeTab(data: string) {
        isMasterPlan.value = data === 'map-plan' ? false : true;
    }

    function onCloseHouseWindow() {
        cardSettingsStore.LAND_PLOT_CARD_IN_MODAL_SET_SHOW_STATUS(false);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["map", { 'map--padded': _unref(cardSettingsStore).store._state.data.landPLotStore.currentSectionZone && _unref(cardSettingsStore).MAP_DOM_RECT.width < 640 }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(MapFigure)
    ]),
    _createVNode(MapHeader, {
      onOpenList: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isListMobWindowVisible) //@ts-ignore
 ? isListMobWindowVisible.value = !_unref(isListMobWindowVisible) : isListMobWindowVisible = !_unref(isListMobWindowVisible))),
      onChangeTab: changeTab,
      class: _normalizeClass({ 'map-header--map': !_unref(isMasterPlan) })
    }, null, 8, ["class"]),
    (_unref(isMasterPlan))
      ? (_openBlock(), _createBlock(MapFooter, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(isListMobWindowVisible))
      ? (_openBlock(), _createBlock(ListMobWindow, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_isRef(isListMobWindowVisible) //@ts-ignore
 ? isListMobWindowVisible.value = false : isListMobWindowVisible = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(CardHouse),
    _createVNode(CardPlotZone),
    (isWindowHouseWindowVisible.value)
      ? (_openBlock(), _createBlock(LandPLotModal, {
          key: 2,
          onClose: onCloseHouseWindow,
          onOpenFilter: _cache[2] || (_cache[2] = ($event: any) => (_isRef(isListMobWindowVisible) //@ts-ignore
 ? isListMobWindowVisible.value = true : isListMobWindowVisible = true))
        }))
      : _createCommentVNode("", true),
    (_unref(galleryStore).SHOW_MODAL)
      ? (_openBlock(), _createBlock(SliderFullScreen, { key: 3 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})